import { render, staticRenderFns } from "./StaffMobileSecurityPopUp.vue?vue&type=template&id=5b101602&"
import script from "./StaffMobileSecurityPopUp.vue?vue&type=script&lang=js&"
export * from "./StaffMobileSecurityPopUp.vue?vue&type=script&lang=js&"
import style0 from "./StaffMobileSecurityPopUp.vue?vue&type=style&index=0&id=5b101602&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports